/**
 * Dashboard-only API configuration.
 * Kept separate from the marketing-site APIs under `src/api/`.
 */

export interface DashboardApiResponse<T = unknown> {
  success: boolean
  message: string
  data?: T
  warning?: string
  errors?: unknown
  unauthorized?: boolean
}

/** Shared with marketing site via VITE_API_BASE_URL; dashboard paths live under /api/admin/. */
export const DASHBOARD_API_BASE_URL =
  import.meta.env.VITE_API_BASE_URL || 'http://72.61.92.71:8000'

/**
 * When false, dashboard overview (and future dashboard modules) serve mock data.
 * Flip to true once the Django admin APIs are ready — same pattern as dayTripApi.
 */
export const USE_DASHBOARD_REAL_BACKEND = true
